module.exports = __webpack_public_path__ + "019.df4d40f1.png";